import { Colors } from '@psl/components/styles/Colors';
import { linking } from '@psl/functions/navigation/linking/config';
import { NavigationContainerRefProvider } from '@psl/functions/navigation/NavigationContainerRefContext';
import { useTrackNavigator } from '@psl/functions/navigation/navigatorTracking';
import {
  DefaultTheme,
  NavigationContainer,
  useNavigationContainerRef,
} from '@react-navigation/native';
import { ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/init-declarations
let __globalNavigationRef: ReturnType<typeof useNavigationContainerRef>;

export function getGlobalNavigationRef() {
  return __globalNavigationRef;
}

export const RoutesContainer = (props: { children: ReactNode }) => {
  const navigationRef = useNavigationContainerRef();
  __globalNavigationRef = navigationRef;

  const { onStateChange, onReady, ref } = useTrackNavigator('', navigationRef);

  return (
    <NavigationContainer
      theme={{
        dark: false,
        colors: {
          ...DefaultTheme.colors,
          primary: Colors.Gray2,
          background: '#000',
        },
      }}
      ref={ref}
      onReady={onReady}
      onStateChange={onStateChange}
      linking={linking}
      documentTitle={{
        enabled: false,
      }}
      fallback={null}
    >
      <NavigationContainerRefProvider navigationRef={navigationRef}>
        {props.children}
      </NavigationContainerRefProvider>
    </NavigationContainer>
  );
};
